/**
 * Demo user list for the sandbox login page.
 *
 * Manually synced with services/api/scripts/seed/users.ts. If you add, remove,
 * or rename a user there, update this file in the same commit.
 */

export const DEMO_PASSWORD = 'Habitia2026!';

export type DemoCategory = 'plataforma' | 'admin' | 'comite' | 'conserje' | 'propietario' | 'residente';

export const DEMO_USER_CATEGORIES: readonly DemoCategory[] = [
  'plataforma',
  'admin',
  'comite',
  'conserje',
  'propietario',
  'residente',
] as const;

export interface DemoUser {
  email: string;
  nombre: string;
  /** Human-readable rol shown on the chip (small caps). */
  rolLabel: string;
  /** Human-readable tenant scope: "A", "B", "A + B", "C", "plataforma". */
  condoLabel: string;
  category: DemoCategory;
}

export const DEMO_USERS: DemoUser[] = [
  { email: 'demo+super@habitia.cl',         nombre: 'Consuelo Vergara',   rolLabel: 'super admin', condoLabel: 'plataforma', category: 'plataforma' },

  { email: 'demo+admin1@habitia.cl',        nombre: 'Matías Olavarría',   rolLabel: 'admin',       condoLabel: 'A + B',      category: 'admin' },
  { email: 'demo+admin2@habitia.cl',        nombre: 'Valentina Rojas',    rolLabel: 'admin',       condoLabel: 'C',          category: 'admin' },

  { email: 'demo+comite-a@habitia.cl',      nombre: 'Javiera Pinto',      rolLabel: 'comité',      condoLabel: 'A',          category: 'comite' },
  { email: 'demo+comite-b@habitia.cl',      nombre: 'Tomás Reyes',        rolLabel: 'comité',      condoLabel: 'B',          category: 'comite' },
  { email: 'demo+comite-c@habitia.cl',      nombre: 'Fernanda Morales',   rolLabel: 'comité',      condoLabel: 'C',          category: 'comite' },

  { email: 'demo+conserje-a@habitia.cl',    nombre: 'Pedro González',     rolLabel: 'conserje',    condoLabel: 'A',          category: 'conserje' },
  { email: 'demo+conserje-b@habitia.cl',    nombre: 'Ana Muñoz',          rolLabel: 'conserje',    condoLabel: 'B',          category: 'conserje' },
  { email: 'demo+conserje-c@habitia.cl',    nombre: 'José Castillo',      rolLabel: 'conserje',    condoLabel: 'C',          category: 'conserje' },

  { email: 'demo+prop-a1@habitia.cl',       nombre: 'Sofía Herrera',      rolLabel: 'propietario', condoLabel: 'A',          category: 'propietario' },
  { email: 'demo+prop-a2@habitia.cl',       nombre: 'Rodrigo Tapia',      rolLabel: 'propietario', condoLabel: 'A',          category: 'propietario' },
  { email: 'demo+prop-a3@habitia.cl',       nombre: 'Camila Soto',        rolLabel: 'propietario', condoLabel: 'A',          category: 'propietario' },
  { email: 'demo+prop-a4@habitia.cl',       nombre: 'Ignacio Poblete',    rolLabel: 'propietario', condoLabel: 'A',          category: 'propietario' },
  { email: 'demo+arrendador-a@habitia.cl',  nombre: 'Rodrigo Astudillo',  rolLabel: 'arrendador',  condoLabel: 'A',          category: 'propietario' },
  { email: 'demo+arrend-a@habitia.cl',      nombre: 'Paulina Cifuentes',  rolLabel: 'arrendataria',condoLabel: 'A',          category: 'residente' },

  { email: 'demo+prop-b1@habitia.cl',       nombre: 'Antonia Quiroga',    rolLabel: 'propietario', condoLabel: 'B',          category: 'propietario' },
  { email: 'demo+prop-b2@habitia.cl',       nombre: 'Diego Vargas',       rolLabel: 'propietario', condoLabel: 'B',          category: 'propietario' },

  { email: 'demo+prop-c1@habitia.cl',       nombre: 'Daniela Henríquez',  rolLabel: 'propietario', condoLabel: 'C',          category: 'propietario' },
  { email: 'demo+prop-c2@habitia.cl',       nombre: 'Jorge Salazar',      rolLabel: 'propietario', condoLabel: 'C',          category: 'propietario' },
  { email: 'demo+moroso-c@habitia.cl',      nombre: 'Mauricio Vega',      rolLabel: 'moroso',      condoLabel: 'C',          category: 'propietario' },
  { email: 'demo+arrendador-c1@habitia.cl', nombre: 'Carolina Pinto',     rolLabel: 'arrendador',  condoLabel: 'C',          category: 'propietario' },
  { email: 'demo+arrend-c1@habitia.cl',     nombre: 'Pablo Fuentes',      rolLabel: 'arrendatario',condoLabel: 'C',          category: 'residente' },
  { email: 'demo+arrendador-c2@habitia.cl', nombre: 'Francisco Leiva',    rolLabel: 'arrendador',  condoLabel: 'C',          category: 'propietario' },
  { email: 'demo+arrend-c2@habitia.cl',     nombre: 'Bárbara Alfaro',     rolLabel: 'arrendataria',condoLabel: 'C',          category: 'residente' },
];
